<template>
  <v-text-field
    label="User Code"
    v-model="userCode"
    @keyup="uppercaseUserCode"
    :maxlength="USER_CODE_LENGTH"
    style="margin: auto; max-width: 320px;"
  ></v-text-field>
</template>

<script>
export default {
  name: "UserCode",

  data: () => ({
    userCode: "",
    USER_CODE_LENGTH: 5
  }),

  methods: {
    uppercaseUserCode() {
      this.userCode = this.userCode.toUpperCase();

      if (this.USER_CODE_LENGTH === this.userCode.length) {
        this.$emit("onValidUserCode", this.userCode);
      } else {
        this.$emit("onInvalidUserCode", this.userCode);
      }
    }
  }
};
</script>
